export default __webpack_public_path__ + "static/media/services-community-management.d406bfdf.svg";